import { Settings2 } from "lucide-react";

export function MobileEmptyState() {
  return (
    <div className="rounded-2xl border border-dashed border-slate-800 bg-slate-950/60 px-6 py-12 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-800 bg-slate-900">
        <Settings2 className="h-5 w-5 text-slate-500" />
      </div>

      <h3 className="mt-4 text-sm font-semibold text-white">
        No transaction policies found
      </h3>

      <p className="mx-auto mt-1 max-w-sm text-xs leading-5 text-slate-500">
        There are no transaction tier policies matching your current filters.
        Create a new policy to configure transaction limits and fees.
      </p>
    </div>
  );
}
